import { OwcCard, OwcGrid } from "@one/react";
import { react18WorkaroundProps } from "../../../utils/constants/constants";
import { Description, THEME, EM_DASH } from "@digitallab/grid-common-frontend-components";

export const EquipmentDetailsDisplay = ({
  equipmentDetails = null
}) => {
  const equipmentDetailsGrid = [
    [
      { label: "Category", value: equipmentDetails.equipmentCategory || equipmentDetails.equipment_category },
      { label: "Manufacturer", value: equipmentDetails.manufacturer },
      { label: "Model", value: equipmentDetails.equipmentModel || equipmentDetails.equipment_model }
    ],
    [
      { label: "Variant", value: equipmentDetails.variant },
      { label: "Nickname", value: equipmentDetails.equipmentNickName || equipmentDetails.equipment_nickname },
      { label: "Location", value: equipmentDetails.locationKey || equipmentDetails.location }
    ],
    [
      { label: "Serial number", value: equipmentDetails.serialNumber || equipmentDetails.serial_number },
      { label: "Equipment ID", value: equipmentDetails.equipmentId || equipmentDetails.equipment_id },
      { label: "Material number", value: equipmentDetails.materialNumber || equipmentDetails.material_number }
    ]
  ];

  return (
    <OwcCard
      style={{
        backgroundColor: THEME["one-color-cobas-gray-50"],
        padding: 0
      }}
      {...react18WorkaroundProps}
    >
      <div
        style={{
          width: "100%",
          overflow: "hidden",
          padding: 0,
          paddingRight: 8
        }}
      >
        {equipmentDetailsGrid.map((row, index) => (
          <div key={"row-" + index}>
            <OwcGrid
              columns={12}
              container
              hGutter={parseInt(THEME["one-spacer-12"])}
              vGutter={parseInt(THEME["one-spacer-24"])}
              {...react18WorkaroundProps}
            >
              {row.map((item, index) => (
                <OwcGrid
                  key={"column-" + index}
                  item
                  xs={12}
                  s={4}
                  style={{ alignSelf: "center" }}
                  {...react18WorkaroundProps}
                >
                  <Description label={item.label} value={item.value && item.value !== "null" ? item.value : EM_DASH} />
                </OwcGrid>
              ))}
            </OwcGrid>
            {index !== equipmentDetailsGrid.length - 1 && <br />}
          </div>
        ))}
      </div>
    </OwcCard>
  );
};
